{
  "tabs": {
    "chat": "ສົນທະນາ",
    "reminders": "ເຕືອນ",
    "calendar": "ປະຕິທິນ",
    "settings": "ຕັ້ງຄ່າ"
  },
  "common": {
    "cancel": "ຍົກເລີກ",
    "save": "ບັນທຶກ",
    "confirm": "ຢືນຢັນ",
    "delete": "ລຶບ",
    "back": "ກັບ",
    "close": "ປິດ",
    "edit": "ແກ້ໄຂ",
    "search": "ຄົ້ນຫາ",
    "all": "ທັງໝົດ",
    "loading": "ກຳລັງໂຫຼດ...",
    "error": "ມີບາງຢ່າງຜິດພາດ",
    "notFound": "ບໍ່ພົບ",
    "tryAgain": "ກະລຸນາລອງໃໝ່",
    "retry": "ລອງໃໝ່",
    "undo": "ກັບຄືນ",
    "pullToRefresh": "ດຶງເພື່ອອັບເດດ",
    "justNow": "ເພີ່ມເທົ່ານັ້ນ"
  },
  "auth": {
    "welcome": "ຍິນດີຕ້ອນຮັບສູ່ FishMemory",
    "tagline": "ຜູ້ຊ່ວຍເຕືອນ WhatsApp ຂອງທ່ານ, ຕອນນີ້ໃນກະເປົາຂອງທ່ານ.",
    "subtitle": "ຜູ້ຊ່ວຍເຕືອນ WhatsApp ຂອງທ່ານ, ຕອນນີ້ໃນກະເປົາຂອງທ່ານ.",
    "phoneLabel": "ເບີ WhatsApp ຂອງທ່ານ",
    "phoneHint": "ພວກເຮົາຈະສົ່ງລະຫັດຢືນຢັນຜ່ານ WhatsApp",
    "invalidPhone": "ກະລຸນາໃສ່ເບີໂທທີ່ຖືກຕ້ອງ",
    "continue": "ດຳເນີນການຕໍ່",
    "enterPhone": "ໃສ່ເບີ WhatsApp ຂອງທ່ານ",
    "phonePlaceholder": "ເບີໂທ",
    "sendCode": "ສົ່ງລະຫັດ",
    "verifyTitle": "ຢືນຢັນເບີຂອງທ່ານ",
    "otpSentTo": "ລະຫັດ 6 ໂຕຖືກສົ່ງໄປທີ່ {{phone}} ຜ່ານ WhatsApp",
    "enterFullCode": "ກະລຸນາໃສ່ລະຫັດ 6 ໂຕທັງໝົດ",
    "invalidOtp": "ລະຫັດບໍ່ຖືກຕ້ອງ. ກະລຸນາລອງໃໝ່.",
    "otpFailed": "ສົ່ງລະຫັດບໍ່ສຳເລັດ. ລອງໃໝ່.",
    "otpResent": "ສົ່ງລະຫັດອີກຄັ້ງ",
    "resendIn": "ສົ່ງອີກໃນ {{seconds}}s",
    "resendCode": "ສົ່ງລະຫັດອີກ",
    "enterOtp": "ໃສ່ລະຫັດທີ່ສົ່ງຫາ WhatsApp ຂອງທ່ານ",
    "verify": "ຢືນຢັນ",
    "resend": "ສົ່ງອີກ",
    "wrongNumber": "ເບີຜິດ?",
    "backToPhone": "ກັບໄປເບີໂທ",
    "editPhone": "ແກ້ໄຂເບີໂທ",
    "error": "ຜິດພາດ",
    "setupTitle": "ມາຕັ້ງຄ່າກັນເດີ້",
    "setupSubtitle": "ທ່ານສາມາດປ່ຽນແປງໄດ້ເມື່ອຫນ້າໃນຕັ້ງຄ່າ",
    "namePlaceholder": "ຊື່ຂອງທ່ານ",
    "letsGo": "ສຳເລັດການຕັ້ງຄ່າ",
    "skipForNow": "ຂ້າມຕອນນີ້"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "ພິມຂໍ້ຄວາມ...",
    "inputPlaceholder": "ພິມຂໍ້ຄວາມ...",
    "typing": "FishMemory ກຳລັງພິມ...",
    "online": "ອອນໄລນ໌",
    "connecting": "ກຳລັງເຊື່ອມຕໍ່...",
    "reconnecting": "ກຳລັງເຊື່ອມຕໍ່ອີກຄັ້ງ...",
    "offline": "ອອບໄລນ໌",
    "empty": "ເລີ່ມສົນທະນາ",
    "emptyHint": "ສ້າງເຕືອນ, ກວດເບິ່ງຕາຕະລາງ, ຫຼືຂໍຄວາມຊ່ວຍເຫຼືອ.",
    "emptyAction": "ສົ່ງເຕືອນຕົວຢ່າງ",
    "actions": "ການດຳເນີນການສົນທະນາ",
    "keep": "ຮັກສາຂໍ້ຄວາມ",
    "clearTitle": "ລ້າງສົນທະນາ",
    "clearConfirm": "ລຶບຂໍ້ຄວາມທັງໝົດຈາກເຄື່ອງນີ້? ບໍ່ສາມາດກູ້ຄືນໄດ້.",
    "clear": "ລ້າງສົນທະນາ",
    "optionSelected": "ເລືອກ: {{label}}",
    "sendingSelection": "ກຳລັງສົ່ງ...",
    "connectionLost": "ກຳລັງເຊື່ອມຕໍ່ອີກຄັ້ງ..."
  },
  "reminders": {
    "title": "ເຕືອນຂອງຂ້ອຍ",
    "active": "ເປັນພາລະກິດ",
    "today": "ມື້ນີ້",
    "thisWeek": "ອາທິດນີ້",
    "history": "ປະຫວັດ",
    "items": "ລາຍການ",
    "emptyTitle": "ຍັງບໍ່ມີເຕືອນ",
    "emptySubtitle": "ສ້າງເຕືອນຈາກການສົນທະນາ ແລະຈະສະແດງທີ່ນີ້.",
    "emptyAction": "ເປີດສົນທະນາ",
    "filterActive": "ເປັນພາລະກິດ",
    "filterToday": "ມື້ນີ້",
    "filterWeek": "ອາທິດນີ້",
    "filterHistory": "ປະຫວັດ",
    "emptyState": "ຍັງບໍ່ມີເຕືອນ. ເລີ່ມສົນທະນາ!",
    "swipeDone": "ເຮັດແລ້ວ",
    "swipeSnooze": "ລ່ອງເວລາ",
    "swipeDelete": "ລຶບ",
    "search": "ຄົ້ນຫາເຕືອນ...",
    "upcoming": "ກຳລັງມາ",
    "completed": "ເຮັດແລ້ວ",
    "overdue": "ເກີນເວລາ",
    "tomorrow": "ມື້ອື່ນ",
    "synced": "ກວດສອບ {{value}}",
    "swipeHint": "ລາຍເຕືອນເພື່ອການດຳເນີນການເພີ່ມເຕີມ",
    "noResults": "ບໍ່ມີເຕືອນທີ່ຕົກລົງກັບການຄົ້ນຫາ",
    "noResultsHint": "ລອງຄຳຄົ້ນຫາອື່ນ ຫຼືລ້າງການຄົ້ນຫາ",
    "deleteAllFailed": "ລຶບເຕືອນທັງໝົດບໍ່ສຳເລັດ"
  },
  "calendar": {
    "title": "ປະຕິທິນ",
    "today": "ມື້ນີ້",
    "tomorrow": "ມື້ອື່ນ",
    "completed": "ເຮັດແລ້ວ",
    "noEvents": "ບໍ່ມີເຫດການ",
    "noEventsSubtitle": "ເລືອກວັນເພື່ອເບິ່ງເຕືອນແລະເຫດການປະຕິທິນ.",
    "googleEvent": "Google Calendar",
    "legendActive": "ເປັນພາລະກິດ",
    "legendRecurring": "ກັບມາຄືນ",
    "legendDone": "ເຮັດແລ້ວ",
    "legendGoogle": "Google",
    "previousMonth": "ເດືອນກ່ອນ",
    "nextMonth": "ເດືອນຖັດໄປ",
    "previousYear": "ປີກ່ອນ",
    "nextYear": "ປີຖັດໄປ",
    "goToToday": "ໄປມື້ນີ້",
    "all": "ທັງໝົດ",
    "active": "ເປັນພາລະກິດ",
    "done": "ເຮັດແລ້ວ",
    "paused": "ຢຸດຊົ່ວຄາວ"
  },
  "settings": {
    "title": "ຕັ້ງຄ່າ",
    "profile": "ໂປຣໄຟລ໌",
    "name": "ຊື່ສະແດງ",
    "enterName": "ໃສ່ຊື່ຂອງທ່ານ",
    "language": "ພາສາ",
    "uiLanguage": "ພາສາແອັບ",
    "uiLanguageHelp": "ປ່ຽນພາສາ UI, ປ້າຍປະຕິທິນ ແລະທິດທາງການຈັດວາງໃນເຄື່ອງນີ້ເທົ່ານັ້ນ.",
    "serverLanguage": "ພາສາສົນທະນາ",
    "serverLanguageHelp": "ປ່ຽນພາສາທີ່ເຊື່ອມຕໍ່ກັບເຊີບເວີ ແລະຂໍ້ຄວາມເຕືອນສໍາລັບບັນຊີຂອງທ່ານ.",
    "timezone": "ເວລາເຂດ",
    "currentTimezone": "ເວລາເຂດປັດຈຸບັນ",
    "timezoneHelp": "ເວລາເຕືອນທັງໝົດຈະສະແດງໃນເວລາເຂດນີ້.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "ບັນທຶກເວລາເຂດ",
    "timezoneSaved": "ເວລາເຂດຖືກອັບເດດ",
    "detect": "ກວດສອບ",
    "detectFailed": "ບໍ່ສາມາດກວດສອບເວລາເຂດ",
    "autoDetect": "ກວດສອບອັດໂນມັດຈາກ GPS",
    "notifications": "ແຈ້ງເຕືອນ",
    "notificationsHelp": "ເຕືອນຕໍ່ເນື່ອງຄວບຄຸມການແຈ້ງເຕືອນຊ້ຳຫຼັງຈາກເຕືອນຖືກສົ່ງ. ສິດທິແຈ້ງເຕືອນລະດັບເຄື່ອງຍັງຄົງຈັດການໃນຕັ້ງຄ່າໂທລະສັບຂອງທ່ານ.",
    "pushEnabled": "ແຈ້ງເຕືອນ Push",
    "autoDoneOnFire": "ເຮັດແລ້ວອັດໂນມັດເມື່ອເຕືອນສົ່ງ",
    "autoDoneOnFireDesc": "ຖ້າປິດໃຊ້, ເຕືອນຈະຢູ່ສະຖານະເປັນເປັນພາລະກິດຈົນກວ່າທ່ານຈະມາມາກຳນົດເຮັດແລ້ວ.",
    "googleCalendar": "Google Calendar",
    "google": "Google Calendar",
    "googleConnected": "ເຊື່ອມຕໍ່ແລ້ວ",
    "googleDisconnected": "ບໍ່ໄດ້ເຊື່ອມຕໍ່",
    "googleConnectedHelp": "ເຕືອນໃໝ່ສາມາດຖືກກວດສອບອັດໂນມັດໃນປະຕິທິນຂອງທ່ານ.",
    "googleDisconnectedHelp": "ເຊື່ອມຕໍ່ Google Calendar ເພື່ອຮັບປະຕິທິນແລະເຕືອນທີ່ກວດສອບກັນ.",
    "googleConnectFailed": "ເຊື່ອມຕໍ່ Google Calendar ບໍ່ສຳເລັດ",
    "connected": "ເຊື່ອມຕໍ່ແລ້ວ",
    "disconnected": "ບໍ່ໄດ້ເຊື່ອມຕໍ່",
    "connect": "ເຊື່ອມຕໍ່",
    "disconnect": "ຕັດການເຊື່ອມຕໍ່",
    "autoSync": "ກວດສອບເຕືອນໃໝ່ອັດໂນມັດ",
    "autosync": "ກວດສອບເຕືອນໃໝ່ອັດໂນມັດ",
    "subscription": "ການສະຫມັກ",
    "trialUsed": "ທົດລອງ: {{used}}/{{total}} ໃຊ້ໄປແລ້ວ",
    "trialStatus": "ມີການທົດລອງ",
    "activeStatus": "ສະຫມັກກຳລັງເປັນຜູ້ໃຊ້",
    "expiredStatus": "ການສະຫມັກໝົດອາຍຸ",
    "unsubscribedStatus": "ບໍ່ໄດ້ສະຫມັກ",
    "about": "ກ່ຽວກັບ",
    "version": "ຮຸ່ນ",
    "logout": "ອອກຈາກລະບົບ",
    "logoutTitle": "ອອກຈາກລະບົບ",
    "logoutConfirm": "ທ່ານແນ່ໃຈບໍ່ວ່າຈະອອກຈາກລະບົບ?",
    "noName": "ບໍ່ໄດ້ຕັ້ງຊື່",
    "serverConnection": "ການເຊື່ອມຕໍ່ເຊີບເວີ",
    "serverUrl": "URL ເຊີບເວີ",
    "serverEdit": "ແກ້ໄຂ",
    "saveReconnect": "ບັນທຶກແລະເຊື່ອມຕໍ່ອີກຄັ້ງ",
    "resetDefault": "ກູ້ຄືນຄ່າຕົ້ນຕໍ່າ",
    "invalidServerUrlTitle": "URL ເຊີບເວີບໍ່ຖືກຕ້ອງ",
    "invalidServerUrlMessage": "ໃສ່ URL ເຊີບເວີ http ຫຼື https ທີ່ຖືກຕ້ອງ, ເຊັ່ນ https://example.com",
    "uiLanguageChangeFailed": "ປ່ຽນພາສາແອັບບໍ່ສຳເລັດ. ກະລຸນາລອງໃໝ່.",
    "serverLanguageChangeFailed": "ປ່ຽນພາສາສົນທະນາບໍ່ສຳເລັດ. ກະລຸນາລອງໃໝ່.",
    "timezoneChangeFailed": "ປ່ຽນເວລາເຂດບໍ່ສຳເລັດ. ກະລຸນາລອງໃໝ່.",
    "autoSyncChangeFailed": "ອັບເດດການກວດສອບອັດໂນມັດບໍ່ສຳເລັດ. ກະລຸນາລອງໃໝ່.",
    "nameChangeFailed": "ອັບເດດຊື່ສະແດງບໍ່ສຳເລັດ. ກະລຸນາລອງໃໝ່.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "ລາຍລະອຽດເຕືອນ",
    "editTime": "ແກ້ໄຂເວລາ",
    "rename": "ປ່ຽນຊື່",
    "snooze": "ລ່ອງເວລາ",
    "snooze15": "ລ່ອງເວລາ 15 ນາທີ",
    "pause": "ຢຸດຊົ່ວຄາວ",
    "pauseReminder": "ຢຸດເຕືອນ",
    "resume": "ດຳເນີນຕໍ່",
    "resumeReminder": "ດຳເນີນເຕືອນຕໍ່",
    "skip": "ຂ້າມຕໍ່ໄປ",
    "skipOccurrence": "ຂ້າມເຫດການນີ້",
    "syncGoogle": "ກວດສອບກັບ Google",
    "delete": "ລຶບ",
    "deleteTitle": "ລຶບເຕືອນ",
    "deleteConfirm": "ເຕືອນນີ້ຈະຖືກລຶບຖາວອນ.",
    "deleteRecurringTitle": "ລຶບເຕືອນທີ່ກັບມາຄືນ",
    "deleteRecurringMessage": "ທ່ານຕ້ອງການຂ້າມເຫດການນີ້ ຫຼືລຶບທຸກເຫດການໃນຊຸດ?",
    "deleteThisOccurrence": "ຂ້າມເຫດການນີ້",
    "deleteEntireSeries": "ລຶບທຸກເຫດການ",
    "done": "ເຮັດແລ້ວ",
    "markDone": "ໝາຍເປັນເຮັດແລ້ວ",
    "undo": "ກູ້ຄືນ",
    "undoPrompt": "ຕ້ອງການໃຫ້ເປັນພາລະກິດອີກບໍ? ກູ້ຄືນດຽວນີ້.",
    "recurring": "ກັບມາຄືນ",
    "nextRun": "ຄັ້ງຕໍ່ໄປ",
    "oneTime": "ເທື່ອດຽວ",
    "pending": "ກຳລັງລໍຖ້າ",
    "sent": "ສົ່ງແລ້ວ",
    "paused": "ຢຸດຊົ່ວຄາວ",
    "active": "ເປັນພາລະກິດ",
    "snoozed": "ລ່ອງເວລາ",
    "localTime": "ສະແດງໃນເວລາທ້ອງຖິ່ນຂອງທ່ານ",
    "recurrence": "ການກັບມາຄືນ",
    "created": "ສ້າງເມື່ອ",
    "tags": "ແທັກ",
    "fireCount": "ຈຳນວນຄັ້ງທີ່ເຕືອນ",
    "actions": "ການດຳເນີນການ",
    "none": "ບໍ່ມີ",
    "snoozeFailed": "ລ່ອງເວລາບໍ່ສຳເລັດ",
    "pauseFailed": "ຢຸດເຕືອນບໍ່ສຳເລັດ",
    "resumeFailed": "ດຳເນີນເຕືອນຕໍ່ບໍ່ສຳເລັດ",
    "skipFailed": "ຂ້າມເຕືອນບໍ່ສຳເລັດ",
    "doneFailed": "ໝາຍເປັນເຮັດແລ້ວບໍ່ສຳເລັດ",
    "undoFailed": "ກູ້ຄືນສະຖານະເຕືອນບໍ່ສຳເລັດ",
    "deleteFailed": "ລຶບເຕືອນບໍ່ສຳເລັດ",
    "rescheduleTitle": "ຈັດຕັ້ງໃໝ່?",
    "rescheduleMsg": "ເຕືອນນີ້ເກີນເວລາແລ້ວ. ທ່ານຕ້ອງການຈັດເວລາໃໝ່ບໍ?",
    "reschedule15": "ໃນ 15 ນາທີ",
    "reschedule60": "ໃນ 1 ຊົ່ວໂມງ",
    "keepOverdue": "ຮັກສາຕາມສະຖານະ"
  },
  "onboarding": {
    "slide1Title": "ຍິນດີຕ້ອນຮັບສູ່ FishMemory",
    "slide1Sub": "ຜູ້ຊ່ວຍເຕືອນສ່ວນຕົວ — ຂັບໂດຍ WhatsApp ແລະສ້າງມາສໍາລັບກະເປົາຂອງທ່ານ.",
    "slide2Title": "ເພີ່ມເຕືອນດ້ວຍພາສາທຳມະຊາດ",
    "slide2Sub": "ພິມເຕືອນຕາມຄວາມຄິດຂອງທ່ານ: \"ເຕືອນຂ້ອຍໃຫ້ໂທຫາແມ່ມື້ອື່ນ 3 ໂມງແລງ\" — ພວກເຮົາຈະຈັດການທັງໝົດ.",
    "slide3Title": "ບໍ່ພາດສິ່ງໃດໆ",
    "slide3Sub": "ໄດ້ຮັບແຈ້ງເຕືອນຕາມເວລາ, ຈັດລຽງດ້ວຍແທັກ, ແລະຕິດຕາມທຸກຢ່າງທີ່ສຳຄັນ.",
    "getStarted": "ເລີ່ມຕົ້ນ",
    "next": "ຕໍ່ໄປ",
    "firstReminderTitle": "ສ້າງເຕືອນຄັ້ງແລກຂອງທ່ານ!",
    "firstReminderHint": "ລອງພິມບາງຢ່າງເຊັ່ນ:",
    "firstReminderExample": "ເຕືອນຂ້ອຍດື່ມນ້ຳມື້ອື່ນ 9 ໂມງເຊົ້າ",
    "gotIt": "ເຂົ້າໃຈແລ້ວ!",
    "notifRationaleTitle": "ຢູ່ໃນເວລາ",
    "notifRationaleBody": "FishMemory ຕ້ອງການແຈ້ງເຕືອນເພື່ອເຕືອນທ່ານໃນເວລາ. ທ່ານຈະໄດ້ຮັບແຈ້ງເຕືອນສໍາລັບເຕືອນທີ່ທ່ານສ້າງເທົ່ານັ້ນ.",
    "notifRationaleAllow": "ເປີດໃຊ້ແຈ້ງເຕືອນ",
    "notifRationaleLater": "ອາດຈະພາຍຫຼັງ",
    "swipeHint": "ລາຍເຕືອນຂວາເພື່ອການດ່ວນ →",
    "calendarDragHint": "ລາຍງານດຶງເພື່ອຂະຫນາດໃຫຍ່ ↕"
  }
}
